/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { ExceptionEntity } from '../exception.model';
import { UrlBuilderService } from '@irian-ro/abstract-resource';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LazyLoadEvent } from 'primeng/api';
import { EnvironmentService } from '@irian-ro/util-environment';

export const skipErrorInterceptor = 'x-skip-error-interceptor';

@Injectable()
export class ExceptionService {
  private endPoint = 'api/exceptions';

  constructor(
    private readonly httpClient: HttpClient,
    private readonly environmentService: EnvironmentService
  ) {
    if (this.environmentService != null) {
      this.endPoint = this.environmentService.getEnvironmentProperty('exceptionsUrl');
    }
  }

  getExceptionsEndPoint() {
    return this.endPoint;
  }

  getAllExceptions(event: LazyLoadEvent): Observable<ExceptionEntity[]> {
    const url = UrlBuilderService.createUrlFromLazyLoadEvent(this.endPoint, event);
    return <Observable<ExceptionEntity[]>>this.httpClient.get<ExceptionEntity[]>(url);
  }

  getExceptionById(id: string): Observable<ExceptionEntity> {
    return this.httpClient.get(`${this.endPoint}/${id}`);
  }

  saveException(exception: ExceptionEntity): Observable<any> {
    const headers = {};
    headers['Content-Type'] = 'application/json; charset=utf-8';
    headers[skipErrorInterceptor] = 'true';
    return this.httpClient.post(this.endPoint, JSON.stringify(exception), {
      headers: new HttpHeaders(headers),
    });
  }
}
